import React from 'react';
import styled from 'styled-components';
import type { ReactNode } from 'react';

import { GridCol, GridRow } from '@zimpel/common/components/Grid';

const LabelWrapper = styled.div`
  color: var(--color-text-secondary);
  text-align: right;
`;

export type LabelRowProps = {
  label?: ReactNode;
  contentColumnCount?: number;
  labelColumnCount?: number;
} & React.PropsWithChildren;

const LabeledRow: React.FC<LabelRowProps> = ({
  label,
  children,
  contentColumnCount = 8,
  labelColumnCount = 3,
}) => (
  <GridRow>
    {label && (
      <GridCol $width={labelColumnCount}>
        <LabelWrapper>
          {label}
        </LabelWrapper>
      </GridCol>
    )}
    <GridCol className="row-content" $padLeft={label ? 1 : labelColumnCount + 1} $width={contentColumnCount}>
      {children}
    </GridCol>
  </GridRow>
);

export default LabeledRow;
